// src/data/waxStampData.js

import wax1 from "../assets/waxstamp/IMG-20250828-WA0009.jpg";
import wax2 from "../assets/waxstamp/IMG-20250828-WA0010.jpg";
import wax3 from "../assets/waxstamp/IMG-20250828-WA0011.jpg";
import wax4 from "../assets/waxstamp/IMG-20250828-WA0012.jpg";

const waxStampData = [
  {
    id: 1,
    name: "Wax Seal full set",
    category: "Wax",
    image: wax1,
     size: "Normal ,Medium",
    description: "Elegant wax stamp ideal for sealing envelopes with a classic touch.",
  },
  {
    id: 2,
    name: "Wax Seal",
    category: "Wax",
    image: wax2,
    size: "35x35 mm",
    description: "Decorative wax stamp featuring detailed engravings for premium sealing.",
  },
  {
    id: 3,
    name: "Wax Seal With Brass Plate",
    category: "Wax",
    image: wax3,
    size: "30x30 mm",
    description: "Round wax stamp perfect for invitations and packaging aesthetics.",
  },
  {
    id: 4,
    name: "Wax in Multi Colors",
    category: "Wax",
    image: wax4,
    size: "Normal",
    description: "Customizable wax stamp for logos, initials, or special events.",
  },
];

export default waxStampData;
